<div class="wizard-steps-wrapper">
  <div class="steps">
    <div
      class="steps-in"
      *ngFor="let step of steps"
      [class.steps-in--active]="step === activeStep"
    ></div>
  </div>
</div>
